var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.96152 5.36404C3.09999 5.36404 2.40157 6.06246 2.40157 6.92399C2.40157 7.78553 3.09999 8.48395 3.96152 8.48395H28.0401C28.9016 8.48395 29.6 7.78553 29.6 6.92399C29.6 6.06246 28.9016 5.36404 28.0401 5.36404H3.96152Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40021 25.0761C2.40021 24.2145 3.09863 23.5161 3.96016 23.5161H28.0387C28.9002 23.5161 29.5987 24.2145 29.5987 25.0761C29.5987 25.9376 28.9002 26.636 28.0387 26.636H3.96016C3.09863 26.636 2.40021 25.9376 2.40021 25.0761Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.95997 14.4399C3.09844 14.4399 2.40002 15.1383 2.40002 15.9999C2.40002 16.8614 3.09844 17.5598 3.95997 17.5598H28.0385C28.9001 17.5598 29.5985 16.8614 29.5985 15.9999C29.5985 15.1383 28.9001 14.4399 28.0385 14.4399H3.95997Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderMenuIcon);
export default __webpack_public_path__ + "static/media/header_menu_icon.5ecf3abfc77bb722373a607f73e35f81.svg";
export { ForwardRef as ReactComponent };